export default __webpack_public_path__ + "static/media/Bitcoin _Monochromatic.15033d42.svg";